// Header.jsx
import React from 'react';
import TopMenu from './TopMenu'; // আপনার নতুন ডাইনামিক মেনু

const Header = () => {
  return (
    <div style={{ 
      display: 'flex', 
      alignItems: 'center', 
	  paddingLeft: '70px'
    }}>
      <TopMenu />
    </div>
  );
};
export default Header;